import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { IconModule } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pp-action-item',
  imports: [IconModule, TranslateModule],
  templateUrl: './action-item.component.html',
  styleUrl: './action-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionItemComponent {
  readonly iconName = input<string>();
  readonly i18nKey = input<string>();
  readonly action = output();
}
